import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './kpi-data.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const KpiDataDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const kpiDataEntity = useAppSelector(state => state.kpiData.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="kpiDataDetailsHeading">
          <Translate contentKey="fleetSenseApp.kpiData.detail.title">KpiData</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.id}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="fleetSenseApp.kpiData.created">Created</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.created ? <TextFormat value={kpiDataEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="odometer">
              <Translate contentKey="fleetSenseApp.kpiData.odometer">Odometer</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.odometer}</dd>
          <dt>
            <span id="distanceTravelled">
              <Translate contentKey="fleetSenseApp.kpiData.distanceTravelled">Distance Travelled</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.distanceTravelled}</dd>
          <dt>
            <span id="speedAvg">
              <Translate contentKey="fleetSenseApp.kpiData.speedAvg">Speed Avg</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.speedAvg}</dd>
          <dt>
            <span id="speedMax">
              <Translate contentKey="fleetSenseApp.kpiData.speedMax">Speed Max</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.speedMax}</dd>
          <dt>
            <span id="speedMin">
              <Translate contentKey="fleetSenseApp.kpiData.speedMin">Speed Min</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.speedMin}</dd>
          <dt>
            <span id="loadAvg">
              <Translate contentKey="fleetSenseApp.kpiData.loadAvg">Load Avg</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.loadAvg}</dd>
          <dt>
            <span id="loadMax">
              <Translate contentKey="fleetSenseApp.kpiData.loadMax">Load Max</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.loadMax}</dd>
          <dt>
            <span id="loadMin">
              <Translate contentKey="fleetSenseApp.kpiData.loadMin">Load Min</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.loadMin}</dd>
          <dt>
            <span id="absCount">
              <Translate contentKey="fleetSenseApp.kpiData.absCount">Abs Count</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.absCount}</dd>
          <dt>
            <span id="absMax">
              <Translate contentKey="fleetSenseApp.kpiData.absMax">Abs Max</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.absMax}</dd>
          <dt>
            <span id="rssCount">
              <Translate contentKey="fleetSenseApp.kpiData.rssCount">Rss Count</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.rssCount}</dd>
          <dt>
            <span id="rssMax">
              <Translate contentKey="fleetSenseApp.kpiData.rssMax">Rss Max</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.rssMax}</dd>
          <dt>
            <span id="breakCount">
              <Translate contentKey="fleetSenseApp.kpiData.breakCount">Break Count</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.breakCount}</dd>
          <dt>
            <span id="breakMax">
              <Translate contentKey="fleetSenseApp.kpiData.breakMax">Break Max</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.breakMax}</dd>
          <dt>
            <span id="breakCountDistanceHundred">
              <Translate contentKey="fleetSenseApp.kpiData.breakCountDistanceHundred">Break Count Distance Hundred</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.breakCountDistanceHundred}</dd>
          <dt>
            <span id="breakMaxOdometerHundred">
              <Translate contentKey="fleetSenseApp.kpiData.breakMaxOdometerHundred">Break Max Odometer Hundred</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.breakMaxOdometerHundred}</dd>
          <dt>
            <span id="alertTotalCount">
              <Translate contentKey="fleetSenseApp.kpiData.alertTotalCount">Alert Total Count</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.alertTotalCount}</dd>
          <dt>
            <span id="alertSensorCount">
              <Translate contentKey="fleetSenseApp.kpiData.alertSensorCount">Alert Sensor Count</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.alertSensorCount}</dd>
          <dt>
            <span id="alertFenceCount">
              <Translate contentKey="fleetSenseApp.kpiData.alertFenceCount">Alert Fence Count</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.alertFenceCount}</dd>
          <dt>
            <span id="alertIdentificationCount">
              <Translate contentKey="fleetSenseApp.kpiData.alertIdentificationCount">Alert Identification Count</Translate>
            </span>
          </dt>
          <dd>{kpiDataEntity.alertIdentificationCount}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.kpiData.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{kpiDataEntity.truckImplement ? kpiDataEntity.truckImplement.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.kpiData.company">Company</Translate>
          </dt>
          <dd>{kpiDataEntity.company ? kpiDataEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/kpi-data" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/kpi-data/${kpiDataEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default KpiDataDetail;
